import { useEffect, useState } from "react";
import { CreateQueryParams, GetSearchParams } from "./ResourceFunctions";
import { useNavigate } from "react-router-dom";
import moment from "moment";

export function useSearchFilter({
  initialFilter,
  initialSort,

  //moment(range.from).format("DD/MM/YYYY")
  // from = new Date(new Date().setDate(new Date().getDate() - 31)),
  from = moment(
    new Date(new Date().setFullYear(new Date().getFullYear() - 1))
  ).format("DD/MM/YYYY"), // Set default "from" date to a year ago

  to = moment(new Date()).format("DD/MM/YYYY"),
}) {
  const pro_date = (date) => new Date(date);
  const confirmDate = (date) => {
    if (pro_date(date).getFullYear() === 1970) {
      return new Date();
    }
    return date;
  };

  const [find, setFind] = useState(false);
  const [sort, setSort] = useState(GetSearchParams("sort") || initialSort || 0);
  const [filter, setFilter] = useState(
    GetSearchParams("filter") || initialFilter || 0
  );
  const [pageSize, setPageSize] = useState(parseInt(GetSearchParams("pageSize")) || 10);
  const [currentPage, setCurrentPage] = useState(
    parseInt(GetSearchParams("currentPage")) || 1
  );
  const [searchText, setSearchText] = useState(
    GetSearchParams("searchText") || ""
  );

  const [vendorId, setVendorId] = useState(GetSearchParams("vendorId") || "");

  const [procurementId, setProcurementId] = useState(
    GetSearchParams("procurementId") || ""
  );

  const initialFrom = GetSearchParams("from");
  const initialTo = GetSearchParams("to");
  const [date, setDate] = useState({
    from: initialFrom
      ? moment(confirmDate(pro_date(initialFrom))).format("DD/MM/YYYY")
      : from,
    to: initialTo
      ? moment(confirmDate(pro_date(initialTo))).format("DD/MM/YYYY")
      : to,
  });

  const navigate = useNavigate();

  const findSearch = () => {
    setFind(!find);
  };

  useEffect(() => {
    const queryParams = CreateQueryParams({
      searchText,
      filter,
      pageSize,
      currentPage,
      from: date?.from,
      to: date?.to,
      sort,
    });

    if (queryParams) {
      navigate(`${queryParams}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [find, currentPage, pageSize]);

  return {
    searchText,
    procurementId,
    vendorId,
    filter,
    pageSize,
    currentPage,
    setSearchText,
    setProcurementId,
    setVendorId,
    setFilter,
    setPageSize,
    setCurrentPage,
    date,
    setDate,
    find,
    findSearch,
    sort,
    setSort,
  };
}
